import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "base-tab" }
const _hoisted_2 = ["innerHTML"]

import BaseSpacer from '@/components/BaseSpacer.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseTabsTab',
  props: {
  title: String,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "base-tab__title",
      innerHTML: __props.title
    }, null, 8, _hoisted_2),
    _createVNode(BaseSpacer, { size: "r" }),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})